import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { catchError, exhaustMap, filter, mergeMap } from "rxjs/operators";
import { ofType } from "redux-observable";
import { tokenExists, getOrganisationBaseUrl, authHeaders } from "frame";
import * as fromOrganisations from "features/organisations";
import fromTypes from "../actions/types";
import * as fromActions from "../actions";

export const featureFlagsFetchEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromTypes.FEATURE_FLAGS_FETCH),
		filter(() => tokenExists()),
		exhaustMap(() =>
			ajax
				.get(
					`${getOrganisationBaseUrl(
						state$.value
					)}/organisation/feature-flags`,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							fromActions.featureFlagsFetchSuccess(
								ajaxResponse.response
							)
						)
					),
					catchError((error) =>
						of(fromActions.featureFlagsFetchFailed(error.message))
					)
				)
		)
	);

export const featureFlagsSaveEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromTypes.FEATURE_FLAGS_SAVE),
		filter(() => tokenExists()),
		mergeMap(({ payload }) =>
			ajax
				.post(
					`${getOrganisationBaseUrl(
						state$.value
					)}/organisation/feature-flags`,
					payload,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							fromActions.featureFlagsSaveSuccess(
								ajaxResponse.response
							),
							fromActions.featureFlagsFetch()
						)
					),
					catchError((error) =>
						of(fromActions.featureFlagsSaveFailed(error.message))
					)
				)
		)
	);

// Refetch feature flags when organization changes or is first loaded
export const featureFlagsRefetchOnOrgChangeEffect = (action$) =>
	action$.pipe(
		ofType(
			fromOrganisations.ORGANISATION_FETCH_SUCCESS,
			fromOrganisations.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED
		),
		filter(() => tokenExists()),
		mergeMap(() => of(fromActions.featureFlagsFetch()))
	);

